<template>
<modal size="large" @close="$emit('close')">
    <template slot="header">
        Tag Tenants for Removal
    </template>

    <template slot="content">
        <div class="mb-3">Please select any tenants who have moved out.</div>

        <div :class="['table-loads', { loading: is_loading_tenants }]">
            <div class="flex jc-sb ai-c mb-4">
                <div class="flex-1">&nbsp;</div>

                <div class="flex-1">
                    <vue-table-pagination
                        ref="tenants_table_pagination"
                        @vuetable-pagination:change-page="onChangePage">
                    </vue-table-pagination>
                </div>

                <div class="flex-1 ta-r">
                    <button @click="loadData">Refresh</button>
                </div>
            </div>

            <form class="flex ai-c mb-4" @submit.prevent="loadData">
                <div style="flex: 0 0 auto; width: 50px;">&nbsp;</div>

                <div class="flex-a mr-3">
                    <label>Filter by First, Last, or Full Name</label>
                    <input type="text" v-model="filters.full_name" />
                </div>

                <div class="flex-0 ml-3">
                    <label>&nbsp;</label>
                    <div class="flex">
                        <button type="reset" class="mr-4" @click="resetFilters">Reset</button>
                        <button type="submit" class="primary">Search</button>
                    </div>
                </div>
            </form>

            <vue-table ref="tenants_table"
                :api-url="api_url"
                :append-params="api_params"
                data-path="data.data"
                pagination-path="data.pagination"
                :fields="columns"
                :http-options="http_options"
                :per-page="50"
                table-height="400px"
                @vuetable:pagination-data="onPaginationData"
                @vuetable:loading="is_loading_tenants = true"
                @vuetable:loaded="is_loading_tenants = false"
                @vuetable:load-error="onTableError"
                @vuetable:row-clicked="onRowClicked">
                <template slot="checkbox" slot-scope="props">
                    <checkbox
                        :alone="true"
                        :center="true"
                        :checked="checked.indexOf(props.rowData.id) !== -1"
                        @click="toggleCheckbox(props.rowData.id)"></checkbox>
                </template>

                <template slot="name" slot-scope="props">
                    {{ props.rowData.last_name }}, {{ props.rowData.first_name }}
                </template>
            </vue-table>
        </div>
    </template>

    <template slot="footer">
        <div class="flex ai-c jc-sb">
            <div>
                <div class="mr-3" v-show="error_message.length">
                    {{ error_message }}
                </div>
            </div>

            <div class="flex">
                <div v-show="is_loading" class="flex ai-c mr-2">
                    <img src="../assets/img/loading-black-32.gif" alt="loading" />
                </div>

                <button :disabled="is_loading || this.checked.length === 0" type="button" @click="onTagTenants">Save</button>
            </div>
        </div>
    </template>
</modal>
</template>

<script>
import Vue from "vue"
import http from "@/http"
import store from "@/store"
import { formatDate } from "../utilities/columns" // eslint-disable-line no-unused-vars

export default {
    name: "managers-tag-tenants-modal",

    props: ["cycle", "facility"],

    data () {
        return {
            checked: [],
            columns: [
                { name: "__slot:checkbox", title: "", dataClass: "center aligned", width: "50px" },
                { name: "unit", sortField: "unit", title: "Unit", width: "125px", dataClass: "center aligned", titleClass: "center aligned" },
                { name: "__slot:name", sortField: "last_name", title: "Name" }
            ],
            error_message: "",
            filters: { full_name: null },
            http_options: {
                baseURL: this.$http.defaults.baseURL,
                headers: {
                    "X-Authorization": store.state.token.token
                },
                transformResponse: [(raw) => {
                    try {
                        return JSON.parse(raw)
                    } catch (error) {
                        this.load_tenants_error = "Unknown error loading tenants."

                        return raw
                    }
                }]
            },
            is_loading: false,
            is_loading_tenants: false,
            tenants: []
        }
    },

    computed: {
        api_params () {
            const params = {}

            if (this.filters.full_name && this.filters.full_name.length !== 0) {
                params.full_name = this.filters.full_name
            }

            return params
        },

        api_url () {
            return `/api/facilities/${this.facility.id}/tenants`
        }
    },

    methods: {
        /**
         * Change the pagination page when requested.
         *
         * @param object page Page
         *
         * @return null
         */
        onChangePage (page) {
            this.$refs.tenants_table.changePage(page)
        },

        /**
         * Update the pagination component when data is received.
         *
         * @param object paginationData Pagination data
         *
         * @return null
         */
        onPaginationData (paginationData) {
            this.$refs.tenants_table_pagination.setPaginationData(paginationData)
        },

        onTableError (error) {
            const { data: { data: message } } = error.response

            this.$eventManager.emit("add-toast", { message: `Error! ${message}`, type: "error" })
        },

        /**
         * Toggle the state of the cycle's checkbox for whichever row was clicked.
         *
         * @param object data  Row data object
         * @param object field Table field configuration
         * @param Event  ev    Event object
         */
        onRowClicked (data, field, ev) {
            this.toggleCheckbox(data.id)
        },

        async onTagTenants () {
            const params = new URLSearchParams()
            params.append("cycle_id", this.cycle.id)
            params.append("ids", this.checked.join(","))

            this.is_loading = true
            this.error_message = ""

            try {
                await http.post("/api/managers/tag-tenants", params)

                this.loadData()
                this.$emit("save")
                this.checked = []
            } catch (ex) {
                this.error_message = ex
            } finally {
                this.is_loading = false
            }
        },

        loadData () {
            Vue.nextTick(() => {
                this.$refs.tenants_table.reload()
            })
        },

        resetFilters () {
            for (const key in this.filters) {
                this.filters[key] = null
            }

            this.loadData()
        },

        /**
         * Toggle the state of a tenants's checkbox.
         *
         * @param int id Tenant ID
         *
         * @return null
         */
        toggleCheckbox (id) {
            if (this.checked.indexOf(id) === -1) {
                this.checked.push(id)
            } else {
                this.checked = this.checked.filter(checkId => checkId !== id)
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ManagersTagTenantsModal.vue